(function () {
    'use strict';

    angular.module("imApp").factory("orderStatusLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listOrderStatusLanguages: function (parms) {
                return $ihttp.post({
                    method: 2514,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2515,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
